import { FormGroups } from 'common/form';

export const campaignCreationSharedJobInformationGroups: FormGroups = {
  jobInformation: {
    label: 'Job information',
    subLabel: 'This can be updated when the campaign is live.',
    labelSx: {
      fontWeight: 400
    },
    variant: 'section'
  },
  additionalDetails: {
    label: 'Add more details',
    subLabel:
      'Popp can refer to this during candidate conversations e.g. industry, candidate opportunity, on or off-site. It can be changed when the campaign is live.',
    labelSx: {
      fontWeight: 400
    },
    sx: {
      width: 600
    },
    variant: 'section'
  }
};
